import script from "./Fixed.vue?vue&type=script&setup=true&lang=js"
export * from "./Fixed.vue?vue&type=script&setup=true&lang=js"

import "./Fixed.vue?vue&type=style&index=0&id=b7e71912&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e71912"]])

export default __exports__